import { IPersonOfBusinessEntity } from '@commenda/types';
import { fetcher } from '@commenda/utils';
import { useQuery } from '@tanstack/react-query';

type UsePersonsInEntityOptions = {
  includeSSN?: boolean;
};

const getPersonsInEntity = async (
  businessEntityId: number,
  options?: UsePersonsInEntityOptions
) => {
  const queryParams = new URLSearchParams();
  if (options?.includeSSN) {
    queryParams.append('includeSSN', 'true');
  }

  const queryString = queryParams.toString();
  const url = `persons/business-entity/${businessEntityId}${queryString ? `?${queryString}` : ''}`;

  const response = await fetcher(url, {
    method: 'GET',
  });

  if (!response.ok) throw new Error('Failed to fetch persons in entity');

  return (await response.json()) as { persons: IPersonOfBusinessEntity[] };
};

export const personsInEntityKeys = {
  FETCH_PERSONS_IN_ENTITY: 'FETCH_PERSONS_IN_ENTITY',
};

const usePersonsInEntity = (
  businessEntityId: number | null | undefined,
  options?: UsePersonsInEntityOptions
) => {
  return useQuery({
    queryKey: [
      personsInEntityKeys.FETCH_PERSONS_IN_ENTITY,
      { businessEntityId, includeSSN: options?.includeSSN },
    ],
    queryFn: () => getPersonsInEntity(businessEntityId as number, options),
    enabled: businessEntityId != null && businessEntityId > 0,
  });
};

export { usePersonsInEntity };
